import { render, staticRenderFns } from "./progres_end.vue?vue&type=template&id=fa6e1942&scoped=true"
import script from "./progres_end.vue?vue&type=script&lang=js"
export * from "./progres_end.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6e1942",
  null
  
)

export default component.exports